import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-business'

/**
 * @deprecated Approval policy v1 response. Remove once `lebt_approval_policy_v2`
 * is fully rolled out and the v1 approval policy endpoint is retired.
 */
type BusinessApprovalPolicyResponse = paths['/api/business-traveller/businesses/{businessId}/approval-policies']['get']['responses'][200]['content']['application/json']

/**
 * @deprecated Approval policy v1 result. Remove once `lebt_approval_policy_v2`
 * is fully rolled out and the v1 approval policy endpoint is retired.
 */
type BusinessApprovalPolicyResult = paths['/api/business-traveller/businesses/{businessId}/approval-policies']['get']['responses'][200]['content']['application/json']['result']

type BusinessApprovalPolicyV2Response = paths['/api/business-traveller/businesses/{businessId}/approval-policies-v2/resolve']['get']['responses'][200]['content']['application/json']

type BusinessApprovalPolicyV2Result = paths['/api/business-traveller/businesses/{businessId}/approval-policies-v2/resolve']['get']['responses'][200]['content']['application/json']['result']

type PolicyItem = BusinessApprovalPolicyResult[number]
type ApprovalPolicyScope = App.BusinessTraveller.ApprovalPolicy['scope']

/**
 * @deprecated Approval policy v1 mapper. Remove once `lebt_approval_policy_v2`
 * is fully rolled out and the v1 approval policy endpoint is retired.
 */
function mapPolicies(policies: BusinessApprovalPolicyResult): Array<App.BusinessTraveller.ApprovalPolicy> {
  return policies.map((policy: PolicyItem) => ({
    id: policy.id,
    name: policy.name,
    scope: policy.scope ?? 'ALWAYS',
    priceBuffer: Number(policy.priceBuffer ?? 0),
    travellers: policy.travellers,
    approvers: policy.approvers,
  }))
}

function mapPolicyV2(policy: BusinessApprovalPolicyV2Result): App.BusinessTraveller.ApprovalPolicy {
  const scopeMap: Record<BusinessApprovalPolicyV2Result['requirement'], ApprovalPolicyScope> = {
    ALWAYS: 'ALWAYS',
    NEVER: 'NEVER',
    OUT_OF_POLICY: 'OUTOFPOLICYONLY',
  }

  return {
    id: policy.id ?? '',
    name: policy.name,
    scope: scopeMap[policy.requirement],
    priceBuffer: Number(policy.priceChangeBuffer ?? 0),
    travellers: [],
    approvers: [],
    resolvedForLoggedInEmployee: true,
  }
}

interface Params {
  businessId: string;
  employeeId: string;
  approvalPolicyV2Enabled?: boolean;
}

async function requestGetPolicy(params: Params) {
  const { businessId, employeeId, approvalPolicyV2Enabled } = params

  try {
    if (approvalPolicyV2Enabled) {
      const policy = await requestUtils.get<BusinessApprovalPolicyV2Response>(
        `/api/business-traveller/businesses/${businessId}/approval-policies-v2/resolve`,
        { credentials: 'include' },
      )

      return mapPolicyV2(policy.result)
    }

    const policies = await requestUtils.get<BusinessApprovalPolicyResponse>(
      `/api/business-traveller/businesses/${businessId}/approval-policies`,
      { credentials: 'include' },
    )

    const mappedPolicies = mapPolicies(policies.result)

    return mappedPolicies.length ? mappedPolicies.find(policy => policy.travellers.includes(employeeId)) : undefined
  } catch(error) {
    return Promise.reject(error)
  }
}

export default requestGetPolicy
